import { useRef } from 'react'
import { useRequest } from 'ahooks'

import { Table } from '@sar/component'
import { UploadImage, UploadFile } from 'components'

import { Spin } from 'antd'
import { ProForm } from '@ant-design/pro-components'

const getData = (data, type) => (
  data
    .filter(e => e.type == type)
    .map(e => ({ url: e.url, filename: e.fileName }))
)

export default function ({ store, params, navigator }) {
  const [
      fileType
    , fileTypeEnums ] = React.useMemo(() => {
    return [
        store.config.getConstantPairs('FileType')
      , store.config.getConstantEnums('FileType')
    ]
  }, [])

  const handleLoad = useRequest<any, any>(
    async () => store.externals.api.get(`/split/${params.id}`).then(result => Object.assign(result, {
      formData: {
          [ fileType.cabinetBody ]: getData(result.fileManageList, fileType.cabinetBody)
        , [ fileType.splitQRCode ]: getData(result.fileManageList, fileType.splitQRCode)
        , [ fileType.doorPanel ]: getData(result.fileManageList, fileType.doorPanel)
        , [ fileType.hardware ]: getData(result.fileManageList, fileType.hardware)
        , [ fileType.PTP ]: getData(result.fileManageList, fileType.PTP)
        , [ fileType.NC ]: getData(result.fileManageList, fileType.NC)
      }
    })),

    {
      manual: true,
    },
  )

  const handleSave = useRequest(
    async (data, type) => store.externals.api.put(`/split/upload/${params.id}?type=${type}`, data.map(elm => {
      return {
        url: elm.url,
        fileName: elm.filename,
      }
    })),

    {
      manual: true,
    },
  )

  const handleUpload = file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(
    res => `//${store.oss.endpoint}/${res.name}`
  )

  return <div className='p-4 m-4 bg-white'>
    <Spin spinning={handleLoad.loading} tip='加载中...'>
      <table className='w-full border-collapse border border-slate-300 mb-2'>
        <tbody>
          <tr>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>订单编号</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{handleLoad.data?.number}</td>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>客户姓名</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{handleLoad.data?.customerName}</td>
          </tr>

          <tr>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>电话</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{handleLoad.data?.customerPhone}</td>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>地址</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{handleLoad.data?.customerAddress}</td>
          </tr>
        </tbody>
      </table>
    </Spin>

    <ProForm
      rowProps={{ gutter: 24 }}
      layout='vertical'
      request={() => handleLoad.runAsync().then(R.prop('formData'))}
      onFinish={() => navigator.back()}
      readonly={!store.identity.hasPermission('/split/list:upload')}
      submitter={!store.identity.hasPermission('/split/list:upload') ? false : {
        searchConfig: {
          submitText: '确定',
        },
        resetButtonProps: {
          style: {
            display: 'none',
          },
        },
      }}
    >
      <UploadFile
        max={10}
        name={fileType.cabinetBody}
        label={`上传${fileTypeEnums[fileType.cabinetBody]}`}
        fieldProps={{ upload: handleUpload }}
        onSave={e => handleSave.runAsync(e, fileType.cabinetBody)}
        readonly={!store.identity.hasPermission('/split/list:upload')}
      />

      <UploadFile
        max={10}
        name={fileType.doorPanel}
        label={`上传${fileTypeEnums[fileType.doorPanel]}`}
        fieldProps={{ upload: handleUpload }}
        onSave={e => handleSave.runAsync(e, fileType.doorPanel)}
        readonly={!store.identity.hasPermission('/split/list:upload')}
      />

      <UploadFile
        max={10}
        name={fileType.hardware}
        label={`上传${fileTypeEnums[fileType.hardware]}`}
        fieldProps={{ upload: handleUpload }}
        onSave={e => handleSave.runAsync(e, fileType.hardware)}
        readonly={!store.identity.hasPermission('/split/list:upload')}
      />

      <UploadFile
        max={10}
        name={fileType.PTP}
        label={`上传${fileTypeEnums[fileType.PTP]}`}
        fieldProps={{ upload: handleUpload }}
        onSave={e => handleSave.runAsync(e, fileType.PTP)}
        readonly={!store.identity.hasPermission('/split/list:upload')}
      />

      <UploadFile
        max={10}
        name={fileType.NC}
        label={`上传${fileTypeEnums[fileType.NC]}`}
        fieldProps={{ upload: handleUpload }}
        onSave={e => handleSave.runAsync(e, fileType.NC)}
        readonly={!store.identity.hasPermission('/split/list:upload')}
      />
    </ProForm>
  </div>
}
